import './TabList.scss';
import React, { isValidElement, memo, ReactElement } from 'react';
import { TabProps } from 'src/modules/common/components/Tab';

type TabElement = ReactElement<TabProps>;
type TabChildren = TabElement | TabElement[] | Array<TabElement | TabElement[] | null>;

type TabListProps = {
  children: TabChildren;
};

export const TabList = memo(({ children }: TabListProps) => {
  const tabs = React.Children.toArray(children).reduce<React.ReactElement<TabProps>[]>((acc, child) => {
    if (Array.isArray(child)) {
      return acc.concat(child.filter(isValidElement<TabProps>));
    }
    if (isValidElement<TabProps>(child)) {
      return acc.concat(child);
    }
    return acc;
  }, []);

  return (
    <div className="bp-tab-list">
      {React.Children.map(tabs, (child, index) => isValidElement(child) &&
      React.cloneElement(child, {
        index,
      }))}
    </div>
  );
});
